<template>

  <popup buttonStyle='primary'
    :heading="utilLabel + ' Bill'"
    :showText="showText"
    :buttonText="utilLabel + ' Bill'"
    :disableButton="!canAccess('finance|admin') || readOnly"
    buttonIcon='fa fa-plug'
    @save="onSaveDialog"
    @close="onCloseDialog">

  <utility-bill-details ref="ubill" :site-data="siteData" />

</popup>

</template>

<script>

import UtilityBillDetails from '@/components/utility/UtilityBillDetails'

export default {

  components: {
    UtilityBillDetails
  },

  props: {

    siteData: {
      type: Object,
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    tableRef: {
      type: String,
      default: 'utiltable'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {

    onSaveDialog () {
      this.$refs.ubill.onSave()
    },

    onCloseDialog () {
      this.$refs.ubill.onClose()
    }
  },

  data () {
    return {
      utilLabel: this.getUtilLabel(this.siteData)
    }
  },  // data

  mounted () {
//    console.log('Util Action:', this.siteData)
  }
}

</script>



// WEBPACK FOOTER //
// UtilityBillAction.vue?2c617f7b